import Icon from '@ant-design/icons';
import { IStructureRenderer } from '@discngine/moosa-models';
import React, { useCallback } from 'react';

import { ReactComponent as CloseIcon } from '../../resources/close.svg';

import styles from './SarMatrixRequestCore.module.less';

export interface ISarMatrixRequestScaffoldProps {
  structure: string;
  index: number;
  onRemove: (index: number) => void;
  onShowEditor: (index: number) => void;
  StructureRenderer: IStructureRenderer;
}

export const SarMatrixRequestScaffold: React.FC<ISarMatrixRequestScaffoldProps> = ({
  structure,
  index,
  onRemove,
  onShowEditor,
  StructureRenderer,
}) => {
  const handleShowEditor = useCallback(() => {
    onShowEditor(index);
  }, [index, onShowEditor]);

  const onCloseIconClick = useCallback(() => {
    onRemove(index);
  }, [onRemove, index]);

  return (
    <div className={styles.coreItem}>
      <div className={styles.coreItemHeader}>
        <div className={styles.coreItemTitle}>Core</div>
        <div>
          <Icon
            className={styles.windowControl}
            component={CloseIcon}
            onClick={onCloseIconClick}
          />
        </div>
      </div>

      {!!structure && (
        <div onClick={handleShowEditor}>
          <StructureRenderer smiles={structure} />
        </div>
      )}
      {!structure && (
        <div className={styles.coreItemText} onClick={handleShowEditor}>
          Click to draw a core structure
        </div>
      )}
    </div>
  );
};
